(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cash-wrap-buy-box"]) return;
  try {
    
  (function () {
    if (customElements.get('cash-wrap-buy-box')) return;

    var decodeEntities = function (s) {
      var t = document.createElement('textarea');
      t.innerHTML = s;
      return t.value;
    };

    // Shopify money formats; drops ".00" like the money_without_trailing_zeros filter
    // exact: always show cents (e.g. $129.00), unless the shop's format has no decimals
    var formatMoney = function (cents, format, exact) {
      var fmt = decodeEntities((format || '$' + '{' + '{amount}' + '}').replace(/<[^>]*>/g, ''));
      var match = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
      var key = match ? match[1] : 'amount';
      var dec = exact || cents % 100 !== 0 ? 2 : 0;
      var num = function (decimals, thousands, decimal) {
        var parts = (cents / 100).toFixed(decimals).split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
        return parts.length > 1 ? parts[0] + decimal + parts[1] : parts[0];
      };
      var out;
      switch (key) {
        case 'amount_no_decimals': out = num(0, ',', '.'); break;
        case 'amount_with_comma_separator': out = num(dec, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': out = num(0, '.', ','); break;
        case 'amount_with_apostrophe_separator': out = num(dec, "'", '.'); break;
        case 'amount_no_decimals_with_space_separator': out = num(0, ' ', ','); break;
        case 'amount_with_space_separator': out = num(dec, ' ', ','); break;
        case 'amount_with_period_and_space_separator': out = num(dec, ' ', '.'); break;
        default: out = num(dec, ',', '.');
      }
      return fmt.replace(/\{\{\s*\w+\s*\}\}/, out);
    };

    var norm = function (s) {
      return String(s == null ? '' : s).trim().toLowerCase();
    };
    var handleize = function (s) {
      return norm(s).replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    };

    class CashWrapBuyBox extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;

        this.data = JSON.parse(this.querySelector('[data-cw-json]').textContent);
        var d = this.data;
        this.form = this.querySelector('form.cw-form');
        this.cta = this.querySelector('[data-cta]');
        this.bar = this.querySelector('[data-bar]');
        this.barCtas = this.querySelectorAll('[data-bar-cta]');
        this.errorEl = this.querySelector('[data-error]');
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
        this.mediaLabel = this.querySelector('[data-media-label]');
        this.thumbsWrap = this.querySelector('[data-thumbs]');
        this.nav = this.querySelector('[data-nav]');
        this.zoomBtn = this.querySelector('[data-zoom]');
        this.main = this.querySelector('.cw-main');
        this.dotsWrap = this.querySelector('[data-dots]');
        // Phones: the main image is a horizontal scroll-snap row (CSS); swiping changes the current image
        this.phone = window.matchMedia('(max-width: 749px)');
        this.variantMedia = d.variants.map(function (v) { return v.media && String(v.media); }).filter(Boolean);
        this.lastTier = this.data.pcts.length || 1;
        // Wallets already in the cart that count toward the tier (refreshed from /cart.js)
        this.cartCount = 0;
        // Pre-discount totals of eligible cart lines, for the "off your cart" amount
        this.cartLines = [];
        this.data.carry = this.data.carry.filter(Boolean);

        var cur = d.variants.find(function (v) { return v.id === d.current; }) || d.variants[0];
        this.state = {
          finish: d.finishIndex >= 0 ? cur.options[d.finishIndex] : null,
          // Pooled hardware: the selected band (properties[Band]); null without the metafield
          band: (this.querySelector('[data-band-input]') || {}).value || null,
          pocket: false,
          qty: 1,
          busy: false,
          added: false,
        };
        // The server already rendered the filtered gallery; this keeps the element lists in the same order
        if (d.hideVariantMedia) this.filterMedia(cur);

        // Ad links can also use ?finish=<finish-name>; ?variant=<id> is handled server-side
        var finishParam = new URLSearchParams(window.location.search).get('finish');
        if (finishParam && d.finishIndex >= 0) {
          var match = d.variants.find(function (v) {
            return handleize(v.options[d.finishIndex]) === handleize(finishParam);
          });
          if (match) this.selectFinish(match.options[d.finishIndex], true);
        }

        this.bindEvents();
        this.render();
        this.setupStickyBar();
        this.setupSlot();
        this.setupSwipe();
        this.setupRatingLine();

        // Count wallets already in the cart, and again whenever the cart changes
        var self = this;
        this.refreshCart();
        // Craft's pubsub.js is deferred, so it may load after this element starts
        var listen = function () {
          if (self.unsubscribeCart || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
          self.unsubscribeCart = subscribe(PUB_SUB_EVENTS.cartUpdate, function () { self.refreshCart(); });
        };
        listen();
        if (!this.unsubscribeCart) document.addEventListener('DOMContentLoaded', listen, { once: true });
        window.addEventListener('pageshow', function (e) { if (e.persisted) self.refreshCart(); });
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.unsubscribeCart) this.unsubscribeCart();
        document.body.classList.remove('cw-bar-visible');
      }

      // Sold-out finishes can still be selected (photos, price, compare table); the CTA shows Sold out
      findVariant(finish) {
        var fi = this.data.finishIndex;
        var matches = this.data.variants.filter(function (v) { return fi < 0 || v.options[fi] === finish; });
        return matches.find(function (v) { return v.available; }) || matches[0];
      }

      variant() {
        return this.findVariant(this.state.finish);
      }

      money(cents, exact) {
        return formatMoney(cents, this.data.moneyFormat, exact);
      }

      // Tier blocks are positions 1..N; the last block covers N and up
      pct(position) {
        var p = this.data.pcts;
        if (!p.length) return 0;
        return (p[Math.min(position, p.length) - 1] || 0) / 100;
      }

      // Products in the "Wallets – volume" collection (theme settings) count toward the tier. With no collection
      // set, only this product counts.
      eligible(productId) {
        var ids = this.data.volumeIds;
        return ids.length ? ids.indexOf(productId) !== -1 : productId === this.data.productId;
      }

      refreshCart() {
        var self = this;
        return fetch(this.data.root.replace(/\/?$/, '/') + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var lines = (cart.items || []).filter(function (item) { return self.eligible(item.product_id); });
            self.cartCount = lines.reduce(function (n, item) { return n + item.quantity; }, 0);
            self.cartLines = lines.map(function (item) {
              return item.original_line_price != null ? item.original_line_price : item.price * item.quantity;
            });
            self.render();
          })
          .catch(function () {});
      }

      // Checked "Complete your carry" add-ons: [{ id, price, eligible }]
      carryItems() {
        var self = this;
        return Array.prototype.slice.call(this.querySelectorAll('[data-carry-check]:checked')).map(function (box) {
          var item = box.closest('[data-carry-item]');
          var select = item.querySelector('[data-carry-variant]');
          var entry = self.data.carry.find(function (c) { return String(c.product) === box.value; });
          var vid = select ? Number(select.value) : entry.variants[0].id;
          var v = entry.variants.find(function (x) { return x.id === vid; }) || entry.variants[0];
          return { id: v.id, price: v.price, eligible: self.eligible(entry.product) };
        });
      }

      // Display-only estimate; Shopify automatic discounts apply the real discount at checkout.
      // count = eligible wallets the cart will hold, so wallets already in the cart move the tier.
      // "cart": every eligible line gets the tier for count. "position": the nth wallet gets tier n.
      estimate(unit, qty, count, startPos) {
        if (this.data.estimate === 'cart') return unit * qty - Math.round(unit * qty * this.pct(count));
        var total = 0;
        for (var i = 1; i <= qty; i++) total += unit - Math.round(unit * this.pct(startPos + i));
        return total;
      }

      selectFinish(finish, silent) {
        this.state.finish = finish;
        this.state.added = false;
        var v = this.variant();
        if (this.data.hideVariantMedia) {
          this.filterMedia(v);
          var first = this.visibleSlides()[0];
          if (first) this.showMedia(v && v.media ? String(v.media) : first.dataset.mediaId);
        } else if (v && v.media) {
          this.showMedia(String(v.media));
        }
        if (!silent) this.render();
      }

      togglePocket() {
        if (!this.data.pocket) return;
        this.state.pocket = !this.state.pocket;
        this.state.added = false;
        this.render();
        document.dispatchEvent(new CustomEvent('cashwrap:pocket-change', { detail: { pocket: this.state.pocket } }));
      }

      setQty(n) {
        this.state.qty = Math.max(1, Math.min(this.data.maxQty, n));
        this.state.added = false;
        this.render();
      }

      // Hide other variants' media: the variant's own image moves to the front, media used by other variants is hidden
      filterMedia(v) {
        var lead = v && v.media ? String(v.media) : null;
        var other = this.variantMedia;
        var out = function (el) { return el.dataset.mediaId !== lead && other.indexOf(el.dataset.mediaId) !== -1; };
        this.slides.forEach(function (s) {
          s.toggleAttribute('data-filtered', out(s));
          if (out(s)) s.hidden = true;
        });
        this.thumbs.forEach(function (t) { t.hidden = out(t); });
        var leadSlide = lead && this.slides.find(function (s) { return s.dataset.mediaId === lead; });
        var leadThumb = lead && this.thumbs.find(function (t) { return t.dataset.mediaId === lead; });
        if (leadSlide) leadSlide.parentNode.insertBefore(leadSlide, this.slides[0]);
        if (leadThumb) this.thumbsWrap.insertBefore(leadThumb, this.thumbsWrap.firstChild);
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
        var many = this.visibleSlides().length > 1;
        if (this.thumbsWrap) this.thumbsWrap.hidden = !many;
        if (this.nav) this.nav.hidden = !many;
        this.renderDots();
      }

      // One dot per shown image; the current one is a pill
      renderDots() {
        if (!this.dotsWrap) return;
        var slides = this.visibleSlides();
        var current = slides.findIndex(function (s) { return !s.hidden; });
        this.dotsWrap.hidden = slides.length < 2;
        if (this.dotsWrap.children.length !== slides.length) {
          this.dotsWrap.innerHTML = slides.map(function () { return '<span class="cw-dot"></span>'; }).join('');
        }
        Array.prototype.forEach.call(this.dotsWrap.children, function (dot, i) {
          dot.classList.toggle('is-active', i === current);
        });
      }

      setupSwipe() {
        var self = this;
        if (!this.main) return;
        this.renderDots();
        var frame = null;
        this.main.addEventListener('scroll', function () {
          if (!self.phone.matches || frame) return;
          frame = requestAnimationFrame(function () {
            frame = null;
            var slides = self.visibleSlides();
            var width = self.main.clientWidth || 1;
            var target = slides[Math.max(0, Math.min(slides.length - 1, Math.round(self.main.scrollLeft / width)))];
            if (target && target.hidden) self.showMedia(target.dataset.mediaId, true);
          });
        }, { passive: true });
        // Back to desktop: no scroll offset left behind
        var reset = function () { if (!self.phone.matches) self.main.scrollLeft = 0; };
        if (this.phone.addEventListener) this.phone.addEventListener('change', reset);
      }

      // Rating line: the rating and count are the Loox widget's group figures (not the product's own metafield
      // count), read from the visually hidden widget once Loox has rendered it. Until then, and if it never renders
      // or its markup changes, the line stays "★★★★★ Reviews".
      // Add bar line under the finish name: "$129", "3 × $129 each", or with a discount "~~$129~~ 3 × $109.65 each"
      // (struck full price, then the discounted price each in green). It stays on one line: if it doesn't fit,
      // "3 ×" goes first, then the struck price ("$109.65 each").
      renderEach(unit, unitNow, qty) {
        var self = this;
        var str = this.data.strings;
        var tpl = str.barEach || '[qty] × [price] each';
        var cut = tpl.indexOf('[price]');
        var before = qty > 1 && cut >= 0 ? tpl.slice(0, cut).replace('[qty]', qty) : '';
        var after = qty > 1 && cut >= 0 ? tpl.slice(cut + 7).replace('[qty]', qty) : '';
        var discounted = unitNow < unit;
        this.querySelectorAll('[data-bar-each]').forEach(function (el) {
          var parts = [];
          if (discounted) {
            var was = document.createElement('s');
            was.className = 'cw-bar__was';
            was.textContent = self.money(unit);
            parts.push(was);
          }
          var now = document.createElement('span');
          now.className = 'cw-bar__now' + (discounted ? ' is-discounted' : '');
          if (before) {
            var q = document.createElement('span');
            q.className = 'cw-bar__qty';
            q.textContent = before;
            now.appendChild(q);
          }
          now.appendChild(document.createTextNode(self.money(discounted ? unitNow : unit) + after));
          parts.push(now);
          el.replaceChildren.apply(el, parts);
        });
        this.fitEach();
      }

      fitEach() {
        this.querySelectorAll('[data-bar-each]').forEach(function (el) {
          el.classList.remove('is-tight', 'is-tighter');
          if (!el.clientWidth || el.scrollWidth <= el.clientWidth + 1) return;
          el.classList.add('is-tight');
          if (el.scrollWidth > el.clientWidth + 1) el.classList.add('is-tighter');
        });
      }

      // "4.9 · 450 reviews": the Loox group figures, from the shared reader (assets/haptic-loox-group.js). Until they
      // arrive, and if Loox never renders, the line keeps its "Reviews" label.
      setupRatingLine() {
        var line = this.querySelector('[data-rating-line]');
        if (!line) return;
        var textEl = line.querySelector('[data-rating-text]');
        var label = line.dataset.countLabel || '[count] reviews';
        var apply = function (g) {
          if (!g || line.classList.contains('is-loaded')) return;
          var strong = document.createElement('strong');
          strong.textContent = g.rating.toFixed(1);
          var count = document.createElement('u');
          count.textContent = label.replace('[count]', g.count);
          textEl.replaceChildren(strong, document.createTextNode(' · '), count);
          line.classList.add('is-loaded');
        };
        if (window.hapticLooxGroup) apply(window.hapticLooxGroup);
        else document.addEventListener('haptic:loox-group', function (e) { apply(e.detail); }, { once: true });
        if (window.HapticLooxGroup) window.HapticLooxGroup.scan();
      }

      // Desktop shows every spec (no "See full specs" toggle); phones keep the toggle
      visibleSlides() {
        return this.slides.filter(function (s) { return !s.hasAttribute('data-filtered'); });
      }

      // fromSwipe: the shopper already scrolled the phone gallery there
      showMedia(mediaId, fromSwipe) {
        var visible = this.visibleSlides();
        var target = visible.find(function (s) { return s.dataset.mediaId === mediaId; });
        if (!target) return;
        this.slides.forEach(function (s) { s.hidden = s !== target; });
        if (this.phone && this.phone.matches && !fromSwipe && this.main) {
          var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.main.scrollTo({ left: target.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
        }
        this.renderDots();
        this.thumbs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.mediaId === mediaId); });
        if (this.zoomBtn) {
          this.zoomBtn.setAttribute(
            'aria-label',
            'Open image ' + (visible.indexOf(target) + 1) + ' of ' + visible.length + ' in full screen'
          );
        }
        var img = target.querySelector('img');
        if (img) img.loading = 'eager';
        if (this.mediaLabel) {
          var labelText = (this.mediaLabel.dataset.template || '').replace('[alt]', target.dataset.label || '').trim();
          this.mediaLabel.textContent = labelText;
          this.mediaLabel.hidden = !labelText;
        }
      }

      stepMedia(dir) {
        var slides = this.visibleSlides();
        if (!slides.length) return;
        var i = slides.findIndex(function (s) { return !s.hidden; });
        var next = slides[(i + dir + slides.length) % slides.length];
        this.showMedia(next.dataset.mediaId);
      }

      // PhotoSwipe (assets/photoswipe*.js, MIT) loads on first hover, focus or tap of the main image
      loadZoom() {
        var self = this;
        var z = this.data.zoom;
        if (!z) return Promise.reject();
        if (this.zoomReady) return this.zoomReady;
        var css = document.querySelector('link[data-pswp-css]');
        var cssReady = Promise.resolve();
        if (!css) {
          css = document.createElement('link');
          css.rel = 'stylesheet';
          css.href = z.css;
          css.setAttribute('data-pswp-css', '');
          cssReady = new Promise(function (resolve) { css.onload = css.onerror = resolve; });
          document.head.appendChild(css);
        }
        this.zoomReady = Promise.all([import(z.lightbox), cssReady]).then(function (r) {
          var lightbox = new r[0].default({
            pswpModule: function () { return import(z.core); },
            showHideAnimationType: 'fade',
            bgOpacity: 1,
            imageClickAction: 'zoom',
            tapAction: 'toggle-controls',
            doubleTapAction: 'zoom',
            closeOnVerticalDrag: true,
            returnFocus: false,
          });
          // Keep the gallery on the image the shopper ended on, then hand focus back to the trigger
          lightbox.on('close', function () {
            var slide = lightbox.pswp && lightbox.pswp.currSlide;
            if (slide && slide.data.mediaId) self.showMedia(slide.data.mediaId);
          });
          lightbox.on('destroy', function () {
            if (self.zoomBtn) self.zoomBtn.focus({ preventScroll: true });
          });
          lightbox.init();
          return lightbox;
        });
        this.zoomReady.catch(function () { self.zoomReady = null; });
        return this.zoomReady;
      }

      openZoom() {
        var slides = this.visibleSlides().filter(function (s) { return s.dataset.zoomSrc; });
        var index = slides.findIndex(function (s) { return !s.hidden; });
        if (index < 0) return;
        var items = slides.map(function (s) {
          var img = s.querySelector('img');
          return {
            src: s.dataset.zoomSrc,
            width: Number(s.dataset.zoomW),
            height: Number(s.dataset.zoomH),
            alt: img ? img.alt : '',
            msrc: img ? img.currentSrc || img.src : undefined,
            mediaId: s.dataset.mediaId,
          };
        });
        this.loadZoom().then(function (lightbox) { lightbox.loadAndOpen(index, items); }, function () {});
      }

      bindEvents() {
        var self = this;
        // Complete your carry: a variant change updates its price and the totals
        this.addEventListener('change', function (e) {
          var select = e.target.closest('[data-carry-variant]');
          if (!select) return;
          var opt = select.options[select.selectedIndex];
          var price = select.closest('[data-carry-item]').querySelector('[data-carry-price]');
          if (price && opt) price.textContent = self.money(Number(opt.dataset.variantPrice));
          self.render();
        });
        // Finish list is a radio group: arrow keys move to and select the previous/next finish
        this.addEventListener('keydown', function (e) {
          var row = e.target.closest('[role="radio"][data-finish], [role="radio"][data-band]');
          if (!row) return;
          var step = { ArrowDown: 1, ArrowRight: 1, ArrowUp: -1, ArrowLeft: -1 }[e.key];
          if (!step) return;
          e.preventDefault();
          var attr = row.dataset.band != null ? 'data-band' : 'data-finish';
          var rows = Array.prototype.slice.call(row.closest('[role="radiogroup"]').querySelectorAll('[role="radio"][' + attr + ']'));
          var next = rows[(rows.indexOf(row) + step + rows.length) % rows.length];
          if (attr === 'data-band') self.selectBand(next.dataset.band);
          else self.selectFinish(next.dataset.finish);
          next.focus();
        });
        this.addEventListener('click', function (e) {
          var el;
          // In-page links like #haptic_leather: template sections get ids like "template--123__haptic_leather"
          if ((el = e.target.closest('a[href^="#"]'))) {
            var anchor = el.getAttribute('href').slice(1);
            if (anchor && !document.getElementById(anchor)) {
              var target = document.querySelector('[id$="__' + CSS.escape(anchor) + '"]');
              if (target) {
                e.preventDefault();
                target.scrollIntoView({ behavior: 'smooth' });
              }
            }
            return;
          }
          if ((el = e.target.closest('[data-band]'))) return self.selectBand(el.dataset.band);
          if ((el = e.target.closest('[data-finish]'))) return self.selectFinish(el.dataset.finish);
          if ((el = e.target.closest('[data-tier]'))) {
            var n = Number(el.dataset.tier);
            return self.setQty(n === self.lastTier ? Math.max(n, self.state.qty) : n);
          }
          if (e.target.closest('[data-inc]')) return self.setQty(self.state.qty + 1);
          if (e.target.closest('[data-dec]')) return self.setQty(Math.max(self.lastTier, self.state.qty - 1));
          if (e.target.closest('[data-pocket-toggle]')) return self.togglePocket();
          if (e.target.closest('[data-carry-check]')) {
            self.state.added = false;
            return self.render();
          }
          if (e.target.closest('[data-zoom]')) return self.openZoom();
          // Phones: tap the image to zoom (the zoom button is hidden there)
          if (self.phone.matches && (el = e.target.closest('[data-slide]'))) {
            self.showMedia(el.dataset.mediaId, true);
            return self.openZoom();
          }
          if ((el = e.target.closest('[data-thumb]'))) return self.showMedia(el.dataset.mediaId);
          if (e.target.closest('[data-prev]')) return self.stepMedia(-1);
          if (e.target.closest('[data-next]')) return self.stepMedia(1);
          if (e.target.closest('[data-bar-cta]')) {
            if (self.form.requestSubmit) self.form.requestSubmit(self.cta);
            else self.addToCart();
          }
        });
        if (this.zoomBtn) {
          var warm = function () { self.loadZoom().catch(function () {}); };
          ['pointerenter', 'pointerdown', 'focus'].forEach(function (type) {
            self.zoomBtn.addEventListener(type, warm, { once: true, passive: true });
          });
        }
        this.form.addEventListener('submit', function (e) {
          e.preventDefault();
          self.addToCart();
        });
      }

      // Pooled hardware: select a band (swatch, picker header, photo pill, properties[Band]); the variant doesn't change
      selectBand(name) {
        var btn = Array.prototype.find.call(this.querySelectorAll('[data-band]'), function (el) { return el.dataset.band === name; });
        if (!btn) return;
        this.state.band = name;
        this.querySelectorAll('[data-band]').forEach(function (el) {
          var on = el === btn;
          el.classList.toggle('is-selected', on);
          el.setAttribute('aria-checked', on);
          el.tabIndex = on ? 0 : -1;
        });
        var input = this.querySelector('[data-band-input]');
        if (input) input.value = name;
        this.setText('.cw-finish--band [data-finish-name], [data-band-name]', name);
        var pill = this.querySelector('[data-band-pill-swatch]');
        if (pill) {
          pill.style.setProperty('--cw-split-a', btn.dataset.bandColor);
          pill.style.setProperty('--cw-split-b', btn.dataset.claspColor);
        }
        this.state.added = false;
        this.showError('');
        document.dispatchEvent(new CustomEvent('cashwrap:band-change', { detail: { band: name } }));
        this.render();
      }

      setText(selector, text) {
        this.querySelectorAll(selector).forEach(function (el) { el.textContent = text; });
      }

      render() {
        var d = this.data;
        var s = this.state;
        var str = d.strings;
        var self = this;
        var v = this.variant();

        this.querySelectorAll('[data-finish]').forEach(function (el) {
          var on = el.dataset.finish === s.finish;
          el.classList.toggle('is-selected', on);
          el.setAttribute('aria-checked', on);
          el.tabIndex = on ? 0 : -1;
        });
        var finishLabel = s.finish != null ? d.finishLabels[s.finish] || s.finish : null;
        // Picker header (tag, description) and the sticky bar swatch follow the selected swatch
        var swatch = this.querySelector('.cw-swatch.is-selected');
        if (swatch) {
          var tagEl = this.querySelector('[data-finish-tag]');
          if (tagEl) {
            tagEl.textContent = swatch.dataset.tag || '';
            tagEl.hidden = !swatch.dataset.tag;
          }
          var descEl = this.querySelector('[data-finish-desc]');
          if (descEl) descEl.textContent = swatch.dataset.desc || '';
          var sepEl = this.querySelector('[data-finish-sep]');
          if (sepEl) sepEl.hidden = !swatch.dataset.desc;
          var about = this.querySelector('[data-about]');
          var aboutFinish = this.querySelector('[data-about-finish]');
          if (about && aboutFinish) {
            aboutFinish.textContent = swatch.dataset.desc
              ? swatch.dataset.desc + ', ' + about.dataset.leather + '.'
              : about.dataset.leatherCap ? about.dataset.leatherCap + '.' : '';
          }
          var swatchImg = swatch.querySelector('img');
          if (swatchImg) {
            var src = swatchImg.currentSrc || swatchImg.src;
            this.querySelectorAll('[data-bar-swatch], [data-sticker-swatch]').forEach(function (img) {
              if (img.getAttribute('src') === src) return;
              img.removeAttribute('srcset');
              img.src = src;
            });
          }
        }
        if (finishLabel != null) this.setText('[data-finish-name]', finishLabel);

        // Other sections (e.g. the finish compare table) follow the selection through this event
        if (s.finish !== this.announcedFinish) {
          this.announcedFinish = s.finish;
          document.dispatchEvent(
            new CustomEvent('cashwrap:finish-change', { detail: { finish: s.finish, variantId: v ? v.id : null } })
          );
        }

        if (!v) return;
        // The pocket is never discounted: wallets get the tier estimate, pockets are added at full price
        var unit = v.price;
        var self = this;
        var carry = this.carryItems();
        var thisEligible = this.eligible(d.productId);
        var count = this.cartCount + (thisEligible ? s.qty : 0) +
          carry.filter(function (c) { return c.eligible; }).length;
        var walletTotal = thisEligible ? this.estimate(unit, s.qty, count, this.cartCount) : unit * s.qty;
        // This wallet's price each after the (cart-aware) tier discount, for the Add bar
        var unitNow = Math.round(walletTotal / s.qty);
        var full = unit * s.qty;
        var pos = this.cartCount + (thisEligible ? s.qty : 0);
        carry.forEach(function (c) {
          full += c.price;
          if (c.eligible) {
            pos += 1;
            walletTotal += self.estimate(c.price, 1, count, pos - 1);
          } else {
            walletTotal += c.price;
          }
        });
        var pocketTotal = s.pocket && d.pocket ? d.pocket.price * s.qty : 0;
        var total = walletTotal + pocketTotal;

        var cartNote = this.querySelector('[data-cart-note]');
        if (cartNote) {
          var pctNow = Math.round(this.pct(count) * 100);
          cartNote.hidden = !(this.cartCount > 0 && str.cartNote);
          cartNote.textContent = (str.cartNote || '')
            .replace('[n]', this.cartCount)
            .replace('[wallets]', this.cartCount === 1 ? 'wallet' : 'wallets')
            .replace('[total]', count)
            .replace('[pct]', pctNow);
        }

        this.setText('[data-price]', this.money(unit));
        var compare = this.querySelector('[data-compare]');
        if (compare) {
          compare.hidden = !(v.compare > v.price);
          compare.textContent = v.compare > v.price ? this.money(v.compare) : '';
        }

        // Card Pocket
        var pocketBtn = this.querySelector('[data-pocket-toggle]');
        if (pocketBtn) {
          pocketBtn.classList.toggle('is-on', s.pocket);
          pocketBtn.setAttribute('aria-pressed', s.pocket);
          pocketBtn.textContent = s.pocket ? str.pocketAdded : str.pocketAdd;
        }

        // Tiers
        var last = this.lastTier;
        this.querySelectorAll('[data-tier]').forEach(function (el) {
          var n = Number(el.dataset.tier);
          var on = n === last ? s.qty >= last : s.qty === n;
          el.classList.toggle('is-selected', on);
          el.setAttribute('aria-pressed', on);
        });
        var stepper = this.querySelector('[data-stepper]');
        if (stepper) stepper.hidden = last < 2 || s.qty < last;
        this.setText('[data-qty]', s.qty);
        // Savings line. [this] = tier discount on what's being added; [cart] = tier discount on every eligible
        // wallet in the cart plus this add (what checkout will take off). Hidden without a discount.
        var thisSaved = full - walletTotal;
        var p = this.pct(count);
        var cartSaved = thisSaved + this.cartLines.reduce(function (n, line) { return n + Math.round(line * p); }, 0);
        var newEligible = (thisEligible ? s.qty : 0) + carry.filter(function (c) { return c.eligible; }).length;
        var saveLine = this.querySelector('[data-saveline]');
        if (saveLine) {
          var tpl = this.cartCount === 0 ? str.saveEmpty : newEligible === 1 ? str.saveOne : str.saveMany;
          saveLine.hidden = !(thisSaved > 0 && tpl);
          if (!saveLine.hidden) {
            this.fillAmounts(saveLine, tpl, { '[this]': this.money(thisSaved, true), '[cart]': this.money(cartSaved, true) });
          }
        }

        // CTA
        var label;
        if (!v.available) label = str.soldOut;
        else if (s.busy) label = str.adding;
        else if (s.added) label = str.added;
        else {
          label = (s.qty > 1 ? str.ctaQty : str.cta).replace('[qty]', s.qty).replace('[price]', this.money(total));
          if (s.pocket && str.ctaPocket) label += ' ' + str.ctaPocket;
        }
        this.cta.textContent = label;
        this.cta.disabled = !v.available;
        this.cta.setAttribute('aria-busy', s.busy);
        if (this.barCtas.length) {
          // "Add 2 · $232.20": the Add bar is the panel's only Add button
          var barState = !v.available ? str.soldOut : s.added ? str.added : '';
          this.setText('[data-bar-cta-phone]', barState ||
            (s.qty > 1 ? str.barPhoneQty : str.barPhone).replace('[qty]', s.qty).replace('[total]', this.money(total)));
          this.barCtas.forEach(function (btn) { btn.disabled = !v.available || s.busy; });
        }
        this.renderEach(unit, unitNow, s.qty);
        this.setText('[data-bar-title]', finishLabel || d.productTitle);

        this.form.querySelector('[data-variant-input]').value = v.id;
        this.form.querySelector('[data-qty-input]').value = s.qty;

        if (window.Shopify && window.Shopify.designMode) return;
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          url.searchParams.delete('finish');
          window.history.replaceState(window.history.state, '', url.toString());
        } catch (e) {}
      }

      // Writes a string with [placeholders] into el; the amounts go in <strong> (bold, savings green)
      fillAmounts(el, template, amounts) {
        el.textContent = '';
        template.split(/(\[this\]|\[cart\])/).forEach(function (part) {
          if (!part) return;
          if (amounts[part] != null) {
            var strong = document.createElement('strong');
            strong.textContent = amounts[part];
            el.appendChild(strong);
          } else {
            el.appendChild(document.createTextNode(part));
          }
        });
      }

      showError(message) {
        if (!this.errorEl) return;
        this.errorEl.textContent = message || '';
        this.errorEl.hidden = !message;
      }

      addToCart() {
        var self = this;
        var d = this.data;
        var v = this.variant();
        if (!v || !v.available || this.state.busy) return;

        this.showError('');
        this.state.busy = true;
        this.render();

        // Same contract as the theme's product-form.js: let the drawer/notification render its own sections
        var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        var sections = cart && typeof cart.getSectionsToRender === 'function'
          ? cart.getSectionsToRender().map(function (sec) { return sec.id; })
          : ['cart-icon-bubble'];
        if (cart && typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);

        // Wallet and Card Pocket go in one request; the pocket line is tagged with the wallet it belongs to
        var items = [{ id: v.id, quantity: this.state.qty }];
        // Line item properties on the form (e.g. properties[Band] for pooled hardware) go on the wallet line
        var props = {};
        var missing = false;
        this.form.querySelectorAll('input[name^="properties["]').forEach(function (input) {
          if (input.required && !input.value) missing = true;
          props[input.name.slice(11, -1)] = input.value;
        });
        if (missing) {
          this.state.busy = false;
          this.showError(d.strings.error);
          this.render();
          return;
        }
        if (Object.keys(props).length) items[0].properties = props;
        this.carryItems().forEach(function (c) { items.push({ id: c.id, quantity: 1 }); });
        if (this.state.pocket && d.pocket) {
          var pocketLine = { id: d.pocket.id, quantity: this.state.qty, properties: {} };
          pocketLine.properties[d.pocketProperty] = d.pocketPropertyValue.replace('[finish]', this.state.finish || '');
          items.push(pocketLine);
        }

        fetch(d.root.replace(/\/?$/, '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: items, sections: sections, sections_url: window.location.pathname }),
        })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            var canPublish = typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined';
            if (res.status) {
              if (canPublish) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'product-form', productVariantId: v.id, errors: res.errors || res.description, message: res.message,
                });
              }
              self.showError(res.description || res.message || d.strings.error);
              return;
            }

            // A multi-item add returns { items, sections }; the theme's drawer and notification expect the
            // single-line shape (id, key), so pass the wallet line with the sections attached
            var walletLine = (res.items || []).find(function (it) { return it.variant_id === v.id; }) || (res.items || [])[0] || {};
            var state = Object.assign({}, walletLine, { sections: res.sections });

            if (canPublish) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: v.id, cartData: state });

            if (cart && typeof cart.renderContents === 'function') {
              cart.renderContents(state);
              cart.classList.remove('is-empty');
            } else {
              var bubble = document.getElementById('cart-icon-bubble');
              var html = res.sections && res.sections['cart-icon-bubble'];
              if (bubble && html) {
                var section = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
                if (section) bubble.innerHTML = section.innerHTML;
              }
              if (d.cartType === 'page') {
                window.location = d.cartUrl;
                return;
              }
            }

            self.state.added = true;
            self.state.qty = 1;
            self.state.pocket = false;
            self.querySelectorAll('[data-carry-check]').forEach(function (box) { box.checked = false; });
            self.refreshCart();
            clearTimeout(self._addedTimer);
            self._addedTimer = setTimeout(function () {
              self.state.added = false;
              self.render();
            }, 2500);
          })
          .catch(function (e) {
            console.error(e);
            self.showError(d.strings.error);
          })
          .finally(function () {
            self.state.busy = false;
            self.render();
          });
      }

      setupStickyBar() {
        if (!this.bar || !('IntersectionObserver' in window)) return;
        var self = this;

        // The floating copy is phones only (tablets and desktop have the Add bar in the panel)
        var update = function () {
          var show = self.phone.matches;
          self.bar.hidden = !show;
          document.body.classList.toggle('cw-bar-visible', show);
          // Keep the last real height while a Craft drawer hides the bar (the panel and spacer use it)
          if (show && self.bar.offsetHeight) document.body.style.setProperty('--cw-bar-h', self.bar.offsetHeight + 'px');
        };
        if ('ResizeObserver' in window) new ResizeObserver(function () { if (!self.bar.hidden) update(); }).observe(this.bar);
        if (this.phone.addEventListener) this.phone.addEventListener('change', update);
        update();
      }

      // Phones: the Add bar has a slot in the page (plain content: it never leaves the slot while the slot is on
      // screen or below it). Once the slot is entirely above the screen, scrolling down shows no bar; after the
      // shopper scrolls up [data-return] px, the floating copy (data-bar) slides up, and it slides away again after
      // they scroll down as far. Scrolling on up to the slot, the copy slides out a bar height before the slot
      // reappears ("near": an observer whose root reaches one bar height above the screen), so only one is on screen.
      setupSlot() {
        var slot = this.querySelector('[data-slot]');
        if (!slot || !('IntersectionObserver' in window)) return;
        var self = this;
        var dist = Number(slot.dataset.return) || 200;
        var near = null;
        var slotH = -1;
        var gone = false; // the slot is entirely above the screen
        var isNear = true; // the slot is on screen or within a bar height above it
        var floating = false;
        var lastY = 0;
        var dir = 0;
        var dirY = 0; // where the current scroll direction started
        var setFloating = function (on) {
          floating = on;
          if (!self.bar) return;
          self.bar.classList.toggle('is-floating', on);
          self.bar.inert = self.phone.matches && !on;
        };
        // Only listens while the slot is above the screen; toggles a class only when the state changes
        var onScroll = function () {
          var y = window.scrollY;
          var d = y > lastY ? 1 : y < lastY ? -1 : 0;
          if (!d) return;
          if (d !== dir) {
            dir = d;
            dirY = lastY;
          }
          lastY = y;
          if (Math.abs(y - dirY) < dist) return;
          if (dir < 0 && !floating && !isNear) setFloating(true);
          else if (dir > 0 && floating) setFloating(false);
        };
        new IntersectionObserver(function (entries) {
          var e = entries[entries.length - 1];
          var nowGone = !e.isIntersecting && e.boundingClientRect.top < 0;
          if (nowGone === gone) return;
          gone = nowGone;
          if (gone) {
            lastY = dirY = window.scrollY;
            dir = 1;
            window.addEventListener('scroll', onScroll, { passive: true });
          } else {
            window.removeEventListener('scroll', onScroll);
            setFloating(false);
          }
        }).observe(slot);
        var observeNear = function () {
          var h = slot.offsetHeight;
          if (!h || h === slotH) return;
          slotH = h;
          if (near) near.disconnect();
          near = new IntersectionObserver(function (entries) {
            var e = entries[entries.length - 1];
            isNear = e.isIntersecting;
            if (isNear) setFloating(false);
          }, { rootMargin: h + 'px 0px 0px 0px' });
          near.observe(slot);
        };
        observeNear();
        if ('ResizeObserver' in window) new ResizeObserver(observeNear).observe(slot);
        // Keep the bar's price line on one line as the width changes
        var eachW = window.innerWidth;
        window.addEventListener('resize', function () {
          if (window.innerWidth !== eachW) {
            eachW = window.innerWidth;
            self.fitEach();
          }
        });
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { self.fitEach(); });
        // The bar's labels differ on phones ("Add 2 · $232.20"); re-render when crossing 750px
        if (this.phone.addEventListener) {
          this.phone.addEventListener('change', function () { self.render(); setFloating(floating); });
        }
        setFloating(false);
      }
    }

    customElements.define('cash-wrap-buy-box', CashWrapBuyBox);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haptic-collection-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('haptic-collection-tabs')) {
    // Tabs layout: chips switch the visible collection (arrow keys move between chips)
    class HapticCollectionTabs extends HTMLElement {
      connectedCallback() {
        this.chips = Array.from(this.querySelectorAll('[data-tab]'));
        if (!this.chips.length) return;
        this.onClick = (e) => {
          const chip = e.target.closest('[data-tab]');
          if (chip) this.select(chip);
        };
        this.onKey = (e) => {
          const i = this.chips.indexOf(e.target);
          if (i < 0 || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
          e.preventDefault();
          const next = this.chips[(i + (e.key === 'ArrowRight' ? 1 : -1) + this.chips.length) % this.chips.length];
          this.select(next);
          next.focus();
        };
        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKey);
      }

      disconnectedCallback() {
        if (!this.onClick) return;
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('keydown', this.onKey);
      }

      select(chip) {
        this.chips.forEach((c) => {
          const on = c === chip;
          c.setAttribute('aria-selected', on);
          c.tabIndex = on ? 0 : -1;
          const panel = this.querySelector('[data-panel="' + c.dataset.tab + '"]');
          if (panel) panel.hidden = !on;
        });
      }
    }
    customElements.define('haptic-collection-tabs', HapticCollectionTabs);

    // In the theme editor, selecting a tab's block shows its panel
    document.addEventListener('shopify:block:select', (e) => {
      const chip = e.target.closest && e.target.closest('[data-tab]');
      const root = chip && chip.closest('haptic-collection-tabs');
      if (root) root.select(chip);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haptic-curated-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('haptic-curated-reviews')) {
    class HapticCuratedReviews extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
        } else {
          this.init();
        }
      }

      init() {
        if (!this.isConnected || this.ready) return;
        this.ready = true;
        this.cards = Array.from(this.querySelectorAll('[data-card]'));
        this.modal = this.querySelector('[data-modal]');
        this.starPath = this.querySelector('template[data-star]').innerHTML;

        this.onClick = (e) => {
          const chip = e.target.closest('[data-filter]');
          if (chip) return this.filter(chip.dataset.filter);
          const open = e.target.closest('[data-open]');
          if (open) return this.open(this.cards.indexOf(open.closest('[data-card]')), open);
          if (e.target.closest('[data-close]')) return this.modal.close();
          if (e.target.closest('[data-prev]')) return this.step(-1);
          if (e.target.closest('[data-next]')) return this.step(1);
          if (e.target.closest('[data-gprev]')) return this.showItem(this.gIndex - 1);
          if (e.target.closest('[data-gnext]')) return this.showItem(this.gIndex + 1);
          const gthumb = e.target.closest('[data-gindex]');
          if (gthumb) return this.showItem(Number(gthumb.dataset.gindex));
          // A click on the backdrop lands on the dialog itself
          if (e.target === this.modal) this.modal.close();
        };
        this.addEventListener('click', this.onClick);

        // Loox group rating and count (assets/haptic-loox-group.js): cached if it already arrived, else an event
        this.onGroup = (e) => this.applyGroup(e.detail);
        if (window.hapticLooxGroup) this.applyGroup(window.hapticLooxGroup);
        else if (this.querySelector('[data-group-heading], [data-group-cta]')) {
          document.addEventListener('haptic:loox-group', this.onGroup, { once: true });
        }

        this.modal.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') {
            e.preventDefault();
            this.step(-1);
          } else if (e.key === 'ArrowRight') {
            e.preventDefault();
            this.step(1);
          } else if (e.key === 'Tab') {
            this.trapFocus(e);
          }
        });
        this.modal.addEventListener('close', () => this.onClose());

        // Swipe left/right in the popup for next/previous
        this.modal.addEventListener('touchstart', (e) => {
          this.touchX = e.touches[0].clientX;
          this.touchY = e.touches[0].clientY;
          this.touchOnMedia = !!e.target.closest('[data-modal-media]');
        }, { passive: true });
        this.modal.addEventListener('touchend', (e) => {
          if (this.touchX == null) return;
          const dx = e.changedTouches[0].clientX - this.touchX;
          const dy = e.changedTouches[0].clientY - this.touchY;
          this.touchX = null;
          if (Math.abs(dx) <= 50 || Math.abs(dx) <= Math.abs(dy) * 1.5) return;
          // On the media, a swipe steps that review's gallery; anywhere else it moves to the previous/next review
          if (this.touchOnMedia && this.items && this.items.length > 1) this.showItem(this.gIndex + (dx < 0 ? 1 : -1));
          else this.step(dx < 0 ? 1 : -1);
        }, { passive: true });
      }

      disconnectedCallback() {
        if (!this.ready) return;
        this.ready = false;
        document.removeEventListener('haptic:loox-group', this.onGroup);
        this.removeEventListener('click', this.onClick);
        if (this.modal.open) this.modal.close();
      }

      // "4.9 out of 5 from 450 reviews", "See all 450 reviews"
      applyGroup(g) {
        if (!g) return;
        const fill = (tpl) => tpl.replace('[rating]', g.rating.toFixed(1)).replace('[count]', g.count);
        const heading = this.querySelector('[data-group-heading]');
        if (heading) heading.textContent = fill(heading.dataset.groupHeading);
        const stars = this.querySelector('[data-group-stars]');
        if (stars && heading) stars.setAttribute('aria-label', g.rating.toFixed(1) + ' out of 5 stars');
        const cta = this.querySelector('[data-group-cta]');
        if (cta) cta.textContent = fill(cta.dataset.groupCta);
      }

      visible() {
        return this.cards.filter((card) => !card.hidden);
      }

      filter(tag) {
        this.querySelectorAll('[data-filter]').forEach((chip) => {
          chip.setAttribute('aria-pressed', chip.dataset.filter === tag);
        });
        this.cards.forEach((card) => {
          if (card.hasAttribute('data-featured')) return;
          card.hidden = tag !== '' && card.dataset.tag !== tag;
        });
        const grid = this.querySelector('[data-hcr-grid]');
        if (grid) grid.scrollLeft = 0;
      }

      stars(n) {
        let html = '';
        for (let i = 1; i <= 5; i++) {
          html += '<svg viewBox="0 0 20 20" class="' + (i > n ? 'is-off' : '') + '" aria-hidden="true">' + this.starPath + '</svg>';
        }
        return html;
      }

      open(index, opener) {
        const card = this.cards[index];
        if (!card) return;
        if (opener) this.opener = opener;
        this.current = index;
        const d = card.dataset;
        const m = this.modal;

        this.buildGallery(card);
        // Rebuilding the gallery removes its old buttons; keep focus (and the arrow keys) inside the popup
        if (m.open && !m.contains(document.activeElement)) m.querySelector('[data-close]').focus();
        m.querySelector('[data-modal-name]').textContent = d.name;
        m.querySelector('[data-modal-verified]').hidden = d.verified !== 'true';
        const stars = m.querySelector('[data-modal-stars]');
        stars.innerHTML = this.stars(Number(d.stars));
        stars.setAttribute('aria-label', d.stars + ' out of 5 stars');
        m.querySelector('[data-modal-date]').textContent = d.date;
        m.querySelector('[data-modal-text]').replaceChildren(card.querySelector('template[data-text]').content.cloneNode(true));
        m.querySelector('[data-modal-item]').hidden = !d.item;
        m.querySelector('[data-modal-item-value]').textContent = d.item;
        m.querySelector('.hcr-modal__scroll').scrollTop = 0;

        const list = this.visible();
        const pos = list.indexOf(card);
        m.querySelector('[data-prev]').hidden = pos <= 0;
        m.querySelector('[data-next]').hidden = pos < 0 || pos >= list.length - 1;

        if (!m.open) {
          m.showModal();
          document.documentElement.style.overflow = 'hidden';
          m.querySelector('[data-close]').focus();
        }
      }

      // Gallery for one review: the card's <template data-item> list (main media first, then extra images)
      buildGallery(card) {
        const m = this.modal;
        this.items = Array.from(card.querySelectorAll('template[data-item]'));
        const multi = this.items.length > 1;
        const thumbs = m.querySelector('[data-gthumbs]');
        const dots = m.querySelector('[data-gdots]');
        thumbs.replaceChildren();
        dots.replaceChildren();
        this.items.forEach((item, i) => {
          const t = document.createElement('button');
          t.type = 'button';
          t.className = 'hcr-gallery__thumb';
          t.dataset.gindex = i;
          t.setAttribute('aria-label', (i + 1) + ' / ' + this.items.length);
          if (item.dataset.thumb) {
            const img = document.createElement('img');
            img.src = item.dataset.thumb;
            img.alt = '';
            t.appendChild(img);
          }
          if (item.dataset.kind === 'video') {
            t.insertAdjacentHTML('beforeend', '<span class="hcr-gallery__thumb-play" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M8 5.5v13l11-6.5z" fill="currentColor"/></svg></span>');
          }
          thumbs.appendChild(t);
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'hcr-gallery__dot';
          dot.dataset.gindex = i;
          dot.setAttribute('aria-label', (i + 1) + ' / ' + this.items.length);
          dots.appendChild(dot);
        });
        thumbs.hidden = !multi;
        dots.hidden = !multi;
        this.gIndex = -1;
        this.showItem(0);
      }

      showItem(i) {
        if (!this.items || i < 0 || i >= this.items.length || i === this.gIndex) return;
        const m = this.modal;
        this.gIndex = i;
        // Replacing the view drops the previous item, so a playing video stops
        m.querySelector('[data-gview]').replaceChildren(this.items[i].content.cloneNode(true));
        m.querySelectorAll('[data-gindex]').forEach((el) => el.setAttribute('aria-current', Number(el.dataset.gindex) === i));
        const multi = this.items.length > 1;
        const prev = m.querySelector('[data-gprev]');
        const next = m.querySelector('[data-gnext]');
        const focused = document.activeElement;
        prev.hidden = !multi || i === 0;
        next.hidden = !multi || i === this.items.length - 1;
        if ((focused === prev && prev.hidden) || (focused === next && next.hidden)) {
          (prev.hidden ? next : prev).focus();
        }
      }

      step(dir) {
        if (!this.modal.open) return;
        const list = this.visible();
        const next = list[list.indexOf(this.cards[this.current]) + dir];
        if (!next) return;
        const focused = document.activeElement;
        this.open(this.cards.indexOf(next));
        // Keep focus inside the popup if the arrow that had it is now hidden
        if (focused && focused.hidden) this.modal.querySelector('[data-close]').focus();
      }

      trapFocus(e) {
        const items = Array.from(
          this.modal.querySelectorAll('a[href], button:not([disabled]), video[controls], [tabindex]:not([tabindex="-1"])')
        ).filter((el) => !el.hidden && el.offsetParent !== null);
        if (!items.length) return;
        const first = items[0];
        const last = items[items.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }

      onClose() {
        // Drop the media so a playing video stops and nothing keeps loading
        this.modal.querySelector('[data-gview]').replaceChildren();
        this.items = null;
        document.documentElement.style.overflow = '';
        const card = this.cards[this.current];
        const target = card && !card.hidden ? card.querySelector('[data-open]') : this.opener;
        if (target) target.focus();
      }
    }
    customElements.define('haptic-curated-reviews', HapticCuratedReviews);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haptic-finish-compare"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('haptic-finish-compare')) {
    class HapticFinishCompare extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
        } else {
          this.init();
        }
      }

      init() {
        if (!this.isConnected || this.ready) return;
        this.ready = true;
        this.labels = JSON.parse(this.querySelector('[data-hfc-labels]').textContent);
        this.scroller = this.querySelector('[data-hfc-scroller]');

        this.onClick = (e) => {
          const link = e.target.closest('[data-choose]');
          if (!link) return;
          if (link.getAttribute('aria-disabled') === 'true') {
            e.preventDefault();
            return;
          }
          // With the buy box on the page, select the finish there; otherwise the link opens the product
          const box = this.buyBox();
          if (box && typeof box.selectFinish === 'function') {
            e.preventDefault();
            this.choose(link, box);
          }
        };
        this.addEventListener('click', this.onClick);

        // The buy box announces every finish change, including its initial one
        this.onFinishChange = (e) => this.highlight(e.detail.finish, e.detail.variantId);
        document.addEventListener('cashwrap:finish-change', this.onFinishChange);
        customElements.whenDefined('cash-wrap-buy-box').then(() => {
          const box = this.buyBox();
          if (box && box.state) this.highlight(box.state.finish, this.boxVariantId(box));
        });

        this.setupHint();
      }

      disconnectedCallback() {
        if (!this.ready) return;
        this.ready = false;
        this.removeEventListener('click', this.onClick);
        document.removeEventListener('cashwrap:finish-change', this.onFinishChange);
      }

      buyBox() {
        return document.querySelector('cash-wrap-buy-box');
      }

      boxVariantId(box) {
        const v = typeof box.variant === 'function' ? box.variant() : null;
        return v ? v.id : null;
      }

      // The column linked to the buy box's variant; failing that, the one with the same finish
      highlight(finish, variantId) {
        const heads = Array.from(this.querySelectorAll('[data-col-head]'));
        const head =
          heads.find((h) => variantId && h.dataset.variantId === String(variantId)) ||
          heads.find((h) => h.dataset.finish && h.dataset.finish === finish);
        const col = head ? head.dataset.col : null;
        this.querySelectorAll('[data-col]').forEach((el) => {
          el.classList.toggle('is-current', el.dataset.col === col);
        });
        this.querySelectorAll('[data-choose]').forEach((link) => {
          const on = link.dataset.col === col;
          if (on) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
          link.querySelector('[data-choose-label]').textContent = on ? this.labels.selected : this.labels.choose;
        });
      }

      choose(link, box) {
        box.selectFinish(link.dataset.choose);
        this.highlight(box.state.finish, this.boxVariantId(box));

        const header = document.querySelector('.section-header');
        const sticky = header && ['sticky', 'fixed'].includes(getComputedStyle(header).position);
        const offset = sticky ? header.getBoundingClientRect().height : 0;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({
          top: box.getBoundingClientRect().top + window.scrollY - offset,
          behavior: reduce ? 'auto' : 'smooth',
        });
      }

      // A one-time "swipe" hint on narrow screens, until the visitor scrolls the table
      setupHint() {
        const hint = this.querySelector('[data-hfc-hint]');
        if (!hint || !this.scroller) return;
        let seen = false;
        try {
          seen = window.localStorage.getItem('haptic-compare-swiped') === '1';
        } catch (e) {}
        if (seen || this.scroller.scrollWidth <= this.scroller.clientWidth + 1) return;
        hint.hidden = false;
        const done = () => {
          hint.classList.add('is-fading');
          setTimeout(() => (hint.hidden = true), 400);
          try {
            window.localStorage.setItem('haptic-compare-swiped', '1');
          } catch (e) {}
        };
        this.scroller.addEventListener('scroll', done, { once: true, passive: true });
      }
    }
    customElements.define('haptic-finish-compare', HapticFinishCompare);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haptic-footer"] && !Shopify.designMode) return;
  try {
    
  // Footer links to a section on another page, like /products/the-cash-wrap#haptic_faq: template sections
  // get ids such as "shopify-section-template--123__haptic_faq", so scroll to the section whose id ends in the hash
  (function () {
    var scrollToHash = function () {
      var key = decodeURIComponent(window.location.hash.slice(1));
      if (!key || document.getElementById(key)) return;
      var target = document.querySelector('[id$="__' + CSS.escape(key) + '"]');
      if (target) target.scrollIntoView();
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scrollToHash);
    } else {
      scrollToHash();
    }
    // Images above the target can move it while they load, so line it up again once the page has loaded
    window.addEventListener('load', scrollToHash, { once: true });
    window.addEventListener('hashchange', scrollToHash);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haptic-included-shipping"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('haptic-included-shipping')) {
    // Follows the buy box: [finish] shows the selected finish; "Card Pocket only" items show while it's added
    class HapticIncludedShipping extends HTMLElement {
      connectedCallback() {
        this.onFinish = (e) => this.setFinish(e.detail.finish);
        this.onPocket = (e) => this.setPocket(e.detail.pocket);
        this.onBand = (e) => this.setFinish(e.detail.band);
        document.addEventListener('cashwrap:finish-change', this.onFinish);
        document.addEventListener('cashwrap:band-change', this.onBand);
        document.addEventListener('cashwrap:pocket-change', this.onPocket);
        customElements.whenDefined('cash-wrap-buy-box').then(() => {
          const box = document.querySelector('cash-wrap-buy-box');
          if (!box || !box.state) return;
          this.setFinish(box.state.band || box.state.finish);
          this.setPocket(box.state.pocket);
        });
      }

      disconnectedCallback() {
        document.removeEventListener('cashwrap:finish-change', this.onFinish);
        document.removeEventListener('cashwrap:band-change', this.onBand);
        document.removeEventListener('cashwrap:pocket-change', this.onPocket);
      }

      setFinish(finish) {
        if (!finish) return;
        this.querySelectorAll('[data-his-finish]').forEach((el) => (el.textContent = finish));
      }

      setPocket(on) {
        this.querySelectorAll('[data-pocket-only]').forEach((el) => (el.hidden = !on));
      }
    }
    customElements.define('haptic-included-shipping', HapticIncludedShipping);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haptic-video-text"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('haptic-video')) {
    // Autoplay: muted loop that plays only while on screen; reduced motion falls back to click to play.
    // Click to play (or the play button in the fallback): plays with sound and native controls.
    class HapticVideo extends HTMLElement {
      connectedCallback() {
        // An element created while the page is still parsing has no children yet
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
        } else {
          this.init();
        }
      }

      init() {
        if (!this.isConnected || this.ready) return;
        this.ready = true;
        this.video = this.querySelector('video');
        this.autoplay = this.dataset.playback === 'autoplay';
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.onClick = (e) => {
          if (e.target.closest('.hvt-video__play')) this.playWithSound();
        };
        this.addEventListener('click', this.onClick);
        if (!this.video) return;
        this.video.addEventListener('playing', () => this.classList.add('is-playing'));
        if (this.autoplay) {
          this.onMotionChange = () => this.sync();
          this.reduceMotion.addEventListener('change', this.onMotionChange);
          this.observer = new IntersectionObserver(
            (entries) => {
              this.inView = entries[entries.length - 1].isIntersecting;
              this.sync();
            },
            { threshold: 0.25 }
          );
          this.observer.observe(this);
        }
      }

      disconnectedCallback() {
        if (!this.ready) return;
        this.ready = false;
        this.removeEventListener('click', this.onClick);
        if (this.observer) this.observer.disconnect();
        if (this.onMotionChange) this.reduceMotion.removeEventListener('change', this.onMotionChange);
      }

      sync() {
        if (this.withSound) return;
        this.classList.toggle('is-reduced', this.reduceMotion.matches);
        if (this.inView && !this.reduceMotion.matches) {
          const playing = this.video.play();
          if (playing) playing.catch(() => {});
        } else {
          this.video.pause();
        }
      }

      playWithSound() {
        if (!this.video) return;
        this.withSound = true;
        this.video.muted = false;
        this.video.controls = true;
        this.classList.add('is-playing');
        const playing = this.video.play();
        if (playing) playing.catch(() => {});
      }
    }
    customElements.define('haptic-video', HapticVideo);

    // A Link block with no URL plays this section's video
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-hvt-play]');
      if (!trigger) return;
      const player = trigger.closest('.hvt') && trigger.closest('.hvt').querySelector('haptic-video');
      if (!player) return;
      e.preventDefault();
      player.scrollIntoView({ behavior: 'smooth', block: 'center' });
      player.playWithSound();
    });

    // A Button block set to "Scroll to the buy box" scrolls there on this page; the link is the fallback
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-hvt-buybox]');
      if (!trigger) return;
      const box = document.querySelector('cash-wrap-buy-box');
      if (!box) return;
      e.preventDefault();
      const header = document.querySelector('.section-header');
      const sticky = header && ['sticky', 'fixed'].includes(getComputedStyle(header).position);
      const offset = sticky ? header.getBoundingClientRect().height : 0;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: box.getBoundingClientRect().top + window.scrollY - offset, behavior: reduce ? 'auto' : 'smooth' });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
